var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruiterIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11540_71067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60254 9C2.60254 4.58172 6.18426 1 10.6025 1H26.6025C31.0208 1 34.6025 4.58172 34.6025 9V25C34.6025 29.4183 31.0208 33 26.6025 33H10.6025C6.18426 33 2.60254 29.4183 2.60254 25V9Z",
    fill: "#1F1D35",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6025 1.5H26.6025C30.7447 1.5 34.1025 4.85786 34.1025 9V25C34.1025 29.1421 30.7447 32.5 26.6025 32.5H10.6025C6.4604 32.5 3.10254 29.1421 3.10254 25V9C3.10254 4.85786 6.4604 1.5 10.6025 1.5Z",
    stroke: "#5B53D7",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2689 23V21.6667C23.2689 20.9594 22.9879 20.2811 22.4878 19.781C21.9877 19.281 21.3095 19 20.6022 19H16.6022C15.895 19 15.2167 19.281 14.7166 19.781C14.2165 20.2811 13.9355 20.9594 13.9355 21.6667V23",
    stroke: "#8B83FB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6022 16.3333C20.075 16.3333 21.2689 15.1394 21.2689 13.6667C21.2689 12.1939 20.075 11 18.6022 11C17.1295 11 15.9355 12.1939 15.9355 13.6667C15.9355 15.1394 17.1295 16.3333 18.6022 16.3333Z",
    stroke: "#8B83FB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11540_71067",
    x: 0.602539,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11540_71067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11540_71067",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiterIconDark);
export default __webpack_public_path__ + "static/media/recruiter-icon-dark.a3da9f03a6839b020fb92163be5afd74.svg";
export { ForwardRef as ReactComponent };